import QuickAdd from '../global/QuickAdd';
import Section from '../Section';

export default class RecentlyViewed extends Section {

  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   */
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.element = element;
    this.wrapper = this.element.closest('[data-recently-viewed-wrapper]');
    this.quickShopDesktopEnabled = this.element.dataset.quickShopDesktopEnabled;
    this.quickShopMobileEnabled = this.element.dataset.quickShopMobileEnabled;

    this.addEventListeners();
  }

  addEventListeners() {
    window.eventBus.on('recentlyViewed:updated', this.onRecentlyViewedUpdated.bind(this));
  }

  onRecentlyViewedUpdated() {
    this.show();
  }

  show = () => {
    this.wrapper.style.display = 'block';

    this.loadShopNow();
    this.quickAddButtons = new QuickAdd(this.theme, this.element);
    this.badge = this.theme.addBadges(this.element, 1000);

    const sectionLoadedEvent = new CustomEvent('theme:section:load');
    document.dispatchEvent(sectionLoadedEvent);

    const recentlyViewedLoadedEvent = new CustomEvent('recentlyViewed:loaded');
    document.dispatchEvent(recentlyViewedLoadedEvent);
  }

  loadShopNow = () => {
    if (this.quickShopDesktopEnabled === 'true' || (this.quickShopMobileEnabled === 'true')) {
      const quickAddButtons = this.element.querySelectorAll('.quick-add-button-variants');
      quickAddButtons.forEach((button) => {
        button.addEventListener('click', this.handleShopNow.bind(this));
      });
    }
  }

  handleShopNow = (e) => {
    e.preventDefault();
    this.theme.toggleRightDrawer('shop-now', true, { url: e.currentTarget.href });
  }

  onUnload() {
    window.eventBus.off('recentlyViewed:updated', this.onRecentlyViewedUpdated);
  }
}
